import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'portal-menu-loading-indicator',
  templateUrl: './menu-loading-indicator.component.html',
  styles: [],
  standalone: false,
})
export class MenuLoadingIndicatorComponent implements OnInit {
  @Input()
  public withContext: boolean = false;

  constructor() {}

  ngOnInit() {}
}
